"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionsList = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var ActionList_style_1 = require("./ActionList.style");
var List_1 = tslib_1.__importDefault(require("@material-ui/core/List"));
var ListItem_1 = tslib_1.__importDefault(require("@material-ui/core/ListItem"));
var ActionsList = function (_a) {
    var actionsId = _a.actionsId, actions = _a.actions, collapseHandler = _a.collapseHandler;
    var INITIAL_ACTION_SELECTED_INDEX = -1;
    var classes = (0, ActionList_style_1.useActionsListStyles)();
    var _b = (0, react_1.useState)(INITIAL_ACTION_SELECTED_INDEX), selectedAction = _b[0], setSelectedAction = _b[1];
    var onActionClickHandler = function (callback, index) {
        var wasNotPreviouslySelected = index !== selectedAction;
        if (wasNotPreviouslySelected) {
            setSelectedAction(index);
            callback();
        }
        collapseHandler();
    };
    return (react_1.default.createElement(List_1.default, { component: "ul", disablePadding: true, "data-signa": "actions-list-".concat(actionsId), classes: { root: classes.actionsList } }, actions.map(function (action, index) { return (react_1.default.createElement(ListItem_1.default, { key: index, disableGutters: true, dense: true, selected: index === selectedAction, onClick: function (event) {
            event.stopPropagation();
            onActionClickHandler(action.onClick, index);
        }, "data-signa": "actions-list-".concat(actionsId, "-action-").concat(index), className: action.labelType ? classes[action.labelType] : '', classes: {
            root: classes.action,
            selected: classes.actionSelected,
        } },
        react_1.default.createElement("span", null, action.label))); })));
};
exports.ActionsList = ActionsList;
